import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { trackPageView } from '@app/libs/facebook_pixel/fbpixel'
import useGoogleAnalytics from '@app/libs/google_analytics/useGoogleAnalytics'

/**
 * Hooks for running third-party scripts
 */
const useThirdParties = () => {
    
    const appMode = import.meta.env.VITE_APP_MODE
    const isProduction = appMode === 'production'    

    const location = useLocation()

    const { sendPageView } = useGoogleAnalytics()

    useEffect(() => {
        if (isProduction && location.pathname) {
            sendPageView()
            trackPageView()
        }
    }, [location, isProduction, sendPageView])
}

export default useThirdParties
